import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";

const TicketManagement = () => {
  const [tickets, setTickets] = useState([]);
  const [comments, setComments] = useState({});

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const ticketsSnapshot = await getDocs(collection(db, "tickets"));
      const ticketList = ticketsSnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((ticket) => ticket.status !== "Resolved"); // Filter out resolved tickets

      setTickets(ticketList);

      // Initialize comments state
      const initialComments = {};
      ticketList.forEach((ticket) => {
        initialComments[ticket.id] = ticket.comment || "";
      });
      setComments(initialComments);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  const updateTicketStatus = async (ticketId, status) => {
    try {
      const ticketRef = doc(db, "tickets", ticketId);
      await updateDoc(ticketRef, { status });
      fetchTickets(); // Refresh tickets after update
    } catch (error) {
      console.error("Error updating ticket status:", error);
    }
  };

  const updateComment = async (ticketId) => {
    try {
      const ticketRef = doc(db, "tickets", ticketId);
      await updateDoc(ticketRef, { comment: comments[ticketId] });
      fetchTickets(); // Refresh tickets after update
    } catch (error) {
      console.error("Error updating comment:", error);
    }
  };

  return (
    <div className="ticket-management-container">
      <h2>Ticket Management</h2>
      {tickets.length === 0 ? (
        <p>No active tickets found.</p>
      ) : (
        tickets.map((ticket) => (
          <div key={ticket.id} className="ticket-card">
            <h4>Order ID: {ticket.orderId}</h4>
            <p><strong>Issue:</strong> {ticket.issueType}</p>
            <p><strong>Description:</strong> {ticket.description}</p>
            <p><strong>Status:</strong> {ticket.status}</p>

            {/* Display Uploaded Images */}
            {ticket.images && ticket.images.length > 0 && (
              <div className="image-preview-container">
                {ticket.images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Ticket Image ${index + 1}`}
                    className="ticket-image-preview"
                  />
                ))}
              </div>
            )}

            {/* Admin Comment Section */}
            <div className="admin-comment-section">
              <label><strong>Admin Comment:</strong></label>
              <textarea
                value={comments[ticket.id] || ""}
                onChange={(e) =>
                  setComments({ ...comments, [ticket.id]: e.target.value })
                }
                placeholder="Add a comment..."
              />
              <button onClick={() => updateComment(ticket.id)}>Save Comment</button>
            </div>

            <div className="ticket-buttons">
              <button onClick={() => updateTicketStatus(ticket.id, "In Progress")}>
                In Progress
              </button>
              <button onClick={() => updateTicketStatus(ticket.id, "Resolved")}>
                Resolved
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default TicketManagement;
